import React from 'react';
import { countryCodeToFlag, countryCodeToName } from 'utils/countryDisplay';
import { EMOJI_SHIELD } from 'utils/constants';

/**
 * Inline country flag + optional anonymized shield indicator.
 *
 * @param {string|null} countryCode - 2-letter ISO country code
 * @param {number|null} isAnonymized - truthy when VPN/proxy/Tor detected
 */
export const GeoIndicator = ({ countryCode, isAnonymized }) => (
    <>
        <span
            role="img"
            aria-label={countryCodeToName(countryCode)}
            title={countryCodeToName(countryCode)}
        >
            {countryCodeToFlag(countryCode)}
        </span>
        {isAnonymized ? (
            <span role="img" aria-label="Anonymized" title="VPN / Proxy / Tor">
                {' '}
                {EMOJI_SHIELD}
            </span>
        ) : null}
    </>
);
